import type { GenericFieldConfig } from '@neo/blocks/forms/types'
import type { RProvider, RModel } from 'v2/pages/flow/sidebar/types'
import {
  type AiAgentNodeData,
  type AiAgentNodeformData,
  FlowNodeTypes,
  type SidebarComponentProps,
} from '../types'
import { v2validations } from '../config/validation.config'
import { GenericSidebarComponent } from './sidebar.base'
import { aiAgentsFields } from './ai-agents/ai-agents-fields'
import { getProviders } from '../utils'

const fields = (nodeVars: string[]): GenericFieldConfig<AiAgentNodeformData> => {
  const validations = v2validations({ nodeVars }).ai_agent_call
  return aiAgentsFields(validations, FlowNodeTypes.ai_agent_call, nodeVars)
}

// NODE_GEN: Update this code, do not commit directly
// Remove this comment after updating the code

export const AiAgentCallSidebarComponent = (props: SidebarComponentProps<AiAgentNodeData>) => {
  const { nodeVars } = props
  const formFields = fields(nodeVars)

  // Get default model config
  const providers = getProviders()
  const defaultProvider =
    providers?.llm_providers.find((p: RProvider) => p.default) || providers?.llm_providers?.[0]
  // Find default model in the provider, regardless of provider's default flag
  const defaultModel =
    defaultProvider?.models.find((m: RModel) => m.default)?.id || defaultProvider?.models?.[0]?.id

  const { selectedNode } = props
  const defaultValues = {
    model_config: {
      provider: selectedNode.data.config.model_config?.provider || defaultProvider?.id,
      model: selectedNode.data.config.model_config?.model || defaultModel,
    },
  }

  return (
    <GenericSidebarComponent
      fields={formFields}
      {...props}
      className="relative"
      defaultValues={defaultValues}
    />
  )
}
